/**
 * `applyMixins` — TypeScript boilerplate for class-mixin composition.
 *
 * Used by `ProjectModel` so that Unity's `partial class ProjectModel`
 * pattern (`ProjectModel_Entities.cs`, `ProjectModel_ApplyServerChanges.cs`,
 * `ProjectModel_AI.cs`) can be ported into one file per concern without
 * losing the single-class shape that `IProjectModel` consumers expect.
 *
 * Standard TypeScript handbook helper; copy-paste from
 * https://www.typescriptlang.org/docs/handbook/mixins.html.
 */

type Ctor = new (...args: unknown[]) => object;

export function applyMixins(target: Ctor, sources: ReadonlyArray<Ctor>): void {
  for (const source of sources) {
    for (const name of Object.getOwnPropertyNames(source.prototype)) {
      if (name === "constructor") continue;
      const descriptor = Object.getOwnPropertyDescriptor(source.prototype, name);
      if (descriptor) {
        Object.defineProperty(target.prototype, name, descriptor);
      }
    }
  }
}
